module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm4.cd7148baa04d7273faa49f7b6efda736.png";